import AgeConfirmModal from './AgeConfirmModal';

export default AgeConfirmModal;


// WEBPACK FOOTER //
// ./src/components/AgeConfirmModal/index.jsx